export const STICKY_NOTE_COLORS = [
  'color_1',
  'color_2',
  'color_3',
  'color_4',
  'color_5',
  'color_6',
] as const;

export type StickyNoteColor = (typeof STICKY_NOTE_COLORS)[number];

export type StickyNoteTargetType = 'priorities_task';

export interface StickyNote {
  id: number;
  user_id: number;
  text: string;
  color: StickyNoteColor;
  /** Pixels from the board's top-left corner. */
  position_x: number;
  position_y: number;
  target_type: StickyNoteTargetType;
  target_id: number;
  created_at: string;
  updated_at: string;
}
